<script setup>
import { globalLoadingVisible } from '@/util/globalLoading'
</script>

<template>
  <Transition name="pikachu-loader-fade">
    <div v-if="globalLoadingVisible" class="pikachu-loader" role="status" aria-live="polite">
      <div class="pikachu-loader-card">
        <div class="pikachu-running-track">
          <span class="pikachu-dust dust-one"></span>
          <span class="pikachu-dust dust-two"></span>
          <span class="pikachu-dust dust-three"></span>
          <div class="pikachu-runner">
            <img src="@/assets/img/mobile_info/皮卡丘.png" alt="Pikachu running" />
          </div>
        </div>
        <p>Loading<span class="loading-dots"><i>.</i><i>.</i><i>.</i></span></p>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.pikachu-loader {
  position: fixed;
  top: auto;
  bottom: 78px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 30000;
  pointer-events: none;
}
.pikachu-loader-card {
  width: 184px;
  height: 54px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 6px 14px 6px 8px;
  border: 2px solid #2466a3;
  border-radius: 27px;
  background: rgba(255, 250, 224, .94);
  box-shadow: 0 3px 10px rgba(0, 38, 78, .18);
}
.pikachu-running-track {
  position: relative;
  width: 88px;
  height: 42px;
  flex: 0 0 88px;
  overflow: hidden;
  border-bottom: 2px solid #efbd1a;
}
.pikachu-runner {
  position: absolute;
  left: 0;
  bottom: 2px;
  width: 40px;
  animation: pikachu-travel 1.25s linear infinite;
}
.pikachu-runner img {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
  transform-origin: center bottom;
  animation: pikachu-bounce .24s ease-in-out infinite alternate;
}
.pikachu-dust {
  position: absolute;
  bottom: 4px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #e3b745;
  opacity: 0;
  animation: dust-fly .72s linear infinite;
}
.dust-one { left: 30px; animation-delay: 0s; }
.dust-two { left: 40px; animation-delay: .2s; width: 3px; height: 3px; }
.dust-three { left: 24px; animation-delay: .4s; width: 3px; height: 3px; }
.pikachu-loader p {
  margin: 0;
  color: #114f8d;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.35;
}
.loading-dots i {
  font-style: normal;
  opacity: .2;
  animation: dot-pulse 1.2s infinite;
}
.loading-dots i:nth-child(2) { animation-delay: .2s; }
.loading-dots i:nth-child(3) { animation-delay: .4s; }
.pikachu-loader-fade-enter-active,
.pikachu-loader-fade-leave-active { transition: opacity .18s ease; }
.pikachu-loader-fade-enter-from,
.pikachu-loader-fade-leave-to { opacity: 0; }
@keyframes pikachu-travel {
  0% { transform: translateX(-43px); }
  100% { transform: translateX(94px); }
}
@media screen and (max-width: 919px) {
  .pikachu-loader {
    top: auto;
    bottom: 66px;
    left: 50%;
  }
  .pikachu-loader-card {
    width: 174px;
    height: 50px;
  }
  .pikachu-running-track {
    width: 82px;
    height: 39px;
    flex-basis: 82px;
  }
}
@keyframes pikachu-bounce {
  from { transform: translateY(0) rotate(-2deg) scaleX(1.02); }
  to { transform: translateY(-6px) rotate(2deg) scaleX(.96); }
}
@keyframes dust-fly {
  0% { transform: translate(20px, 0) scale(.3); opacity: 0; }
  30% { opacity: .75; }
  100% { transform: translate(-24px, -15px) scale(1.2); opacity: 0; }
}
@keyframes dot-pulse {
  0%, 70%, 100% { opacity: .2; }
  35% { opacity: 1; }
}
@media (prefers-reduced-motion: reduce) {
  .pikachu-runner,
  .pikachu-runner img,
  .pikachu-dust,
  .loading-dots i { animation-duration: 2.4s; }
}
</style>
